import request from '@/services/request';

export const create = data => request.post('subscription', data);

export const findBySubscriber = pagination => request
  .get('subscription/subscriber', { params: pagination });

export const cancel = id => request.delete(`subscription/${id}`);

export const resume = id => request.patch(`subscription/${id}/resume`);
